import React, { FunctionComponent } from "react";
import { ComponentProps } from "../components/component-props";
import { Demo } from "../components/demo";

const tabCode = `const TabDemo = () => {
    const [activeIndex, setActiveIndex] = React.useState(0);
    return (
        <TabBar
            activeTabIndex={activeIndex}
            onActivate={evt => setActiveIndex(evt.detail.index)}
        >
            <Tab>Dashboard</Tab>
            <Tab>CMS</Tab>
            <Tab>Commerce</Tab>
            <Tab>Developer</Tab>
            <Tab>Social Reach</Tab>
            <Tab>Personalization</Tab>
            <Tab>Insight</Tab>
            <Tab>Campaign</Tab>
            <Tab>Find</Tab>
            <Tab>Power BI</Tab>
        </TabBar>
    );
};

render(<TabDemo />);`;

const tabDemo = {
    code: tabCode,
    noInline: true
};

export const TabDemo: FunctionComponent = () => {
    return (
        <Demo demo={tabDemo}>
            <ComponentProps componentName="TabBar" />
            <ComponentProps componentName="Tab" />
        </Demo>
    );
};
